module.exports = new __parcel__URL__("grand-theft-auto-vice-city.457d62a4.jpg").toString();